import React from 'react';
import { css } from '@emotion/core'
import { containers, Grid } from 'style';
import { Markdown } from '..';

const ThreeColumnText = ({
    column1,
    column2,
    column3
}) => (
        <Grid.Wrapper
            className="wrapper"
            id="ThreeColumnText">
                <div className="container-fluid">
                    <div class="row between-xs">
                        <div className="col-xs-12" css={left_css}>
                            <Markdown source={column1} />
                        </div>
                        <div className="col-xs-12" css={left_css}>
                            <Markdown source={column2} />
                        </div>
                        <div className="col-xs-12" css={right_css}>
                            <Markdown source={column3} />
                        </div>
                    </div>
                </div>
        </Grid.Wrapper>
    );

const right_css = css`
    flex: 1 0 100%;
    max-width: 100%;
    white-space: pre-wrap;


    @media (min-width: ${containers.ipad}px) {
      flex: 1 0 22.22222222222222vw;
      min-width: auto;
      max-width: 22.22222222222222vw;
    }

    h3{
      margin-bottom: 0;
    }

`;
const left_css = css`
    ${right_css};
    padding-bottom: 5.5vw;
`;

export default ThreeColumnText;
